export default function ValidationsProcesso() {

    const validateFields = (fields) => {
        const {
            servico,
            tipo,
            nomeProcesso,
            descricao,
        } = fields;
        const errors = {};

        if (!servico || !servico.value) {
            errors.servico = "Pelo menos um serviço deve ser selecionado.";
        }
        if (!tipo || !tipo.value) {
            errors.tipo = "Pelo menos um tipo deve ser selecionado.";
        }
        if (!nomeProcesso || nomeProcesso.trim() === "") {
            errors.nomeProcesso = "O campo Processo é obrigatório.";
        }
        if (!descricao || descricao.trim() === "") {
            errors.descricao = "O campo Descrição é obrigatório.";
        }
       
        return errors;
    };

    return {
        validateFields
    }
}
